import { useContext } from 'react';
import HistoriaContext, { StadiumMaterialuHistoriaContextContent }
  from '../StadiumMaterialuHistoriaContext';

export default ():
  StadiumMaterialuHistoriaContextContent => useContext(HistoriaContext);
